<span class="inputSpacer__delimiter" style="width: {{delimiterWidth}}px">{{#if delimiter}}{{delimiter}}{{/if}}</span>
